import React, { useState, useEffect } from "react";
import imglogo from "../../../assets/common/logo_rb.png";
import YouTube from "react-youtube";
import { useLocation, useParams } from "react-router-dom";
import { Fancybox } from "../../../components";
import { getprojectbyid } from "../../../services/projects";
import parse from "html-react-parser";
import { withTranslation } from "react-i18next";

import {
  convertStringToArray,
  formatNumber,
  decryptString,
} from "../../../utils/common/hashData";
import { Icon } from "@iconify/react/dist/iconify.js";
const ActivityDetail = (props) => {
  const [videoId] = useState("04uZ36O46Jo"); // Default video ID
  const location = useLocation();
  // const datadetail = location?.state?.data || {}; // Added fallback to empty object
  const { t } = props;

  const id = location.state?.id || null;
  const { id: idParam } = useParams();

  const [datadetail, setDatadetail] = useState({
    architecture: "",
    completionDate: "",
    content: "",
    investor: "",
    location: "",
    name: "",
    pictureGallery: "",
    pictureUrl: "",
    price: null,
    scale: "",
    status: "",
    thumbnail: "",
    type: "",
    website: "",
  });

  const getprojectbyID = async () => {
    await getprojectbyid(
      id
        ? decryptString({
            encryptedStr: id,
            secretKey: process.env.PRIVATE_KEY,
          })
        : decryptString({
            encryptedStr: idParam,
            secretKey: process.env.PRIVATE_KEY,
          })
    )
      .then((res) => {
        setDatadetail(res.data.data);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };
  useEffect(() => {
    getprojectbyID();
  }, []);
  const opts = {
    height: "360",
    width: "100%",
    playerVars: {
      autoplay: 0, // Don't autoplay on load
    },
  };

  return (
    <div className="w-full">
      {/* Banner */}
      <div className="relative w-full h-[50vh] md:h-[calc(100vh-132px)] overflow-hidden">
        <img
          src={datadetail?.thumbnail}
          className="absolute w-full h-full object-cover object-bottom"
          alt="Project Banner"
        />
      </div>
      <div className="max-w-[1140px] mx-auto pt-10 w-[80%]  qhd:max-w-[100%] qhd:w-[100%] ">
        {/* Project info basic */}
        <div className="pb-2">
          <div className="">
            <p className=" pb-[1.25rem] pv:max-lg:pb-2 text-[2.5rem] qhd:text-[2.5rem]  font-medium text-primary leading-tight">
              {datadetail?.name}
            </p>
          </div>
          <div className="">
            <p className="text-[1.125rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary text-justify leading-relaxed">
              {datadetail?.location}
            </p>
          </div>
        </div>
        {/* Picture gallery */}
        <div className="grid grid-cols-3 gap-4 pv:max-lg:grid-cols-1">
          <div className="col-span-2 pv:max-lg:col-span-1">
            <Fancybox
              options={{
                Carousel: {
                  infinite: false,
                },
              }}
            >
              {convertStringToArray(datadetail?.pictureGallery)?.map(
                (item, index) => {
                  return (
                    <div
                      className={`overflow-hidden ${index === 0 ? "" : "hidden"}`}
                    >
                      <a className="" data-fancybox="gallery" href={item}>
                        <img
                          src={item}
                          alt="Main"
                          className="cursor-zoom-in w-full md:h-[400px] object-cover rounded-lg "
                        />
                      </a>
                    </div>
                  );
                }
              )}
            </Fancybox>
          </div>
          <div className="col-span-1 pv:max-lg:col-span-1">
            <Fancybox
              options={{
                Carousel: {
                  infinite: false,
                },
              }}
            >
              <div className=" grid  gap-4 pv:max-lg:grid-cols-2 ">
                {convertStringToArray(datadetail?.pictureGallery)?.map(
                  (item, index) => {
                    return (
                      <div
                        key={index}
                        className={`rounded-lg ${index === 2 ? "shadow-custom-image " : ""} overflow-hidden ${index === 0 || index >= 3 ? "hidden" : ""}`}
                      >
                        {item ? (
                          <a
                            className="relative"
                            data-fancybox="gallery"
                            href={item}
                          >
                            <img
                              src={item}
                              alt={`Thumbnail ${index + 1}`}
                              className={` cursor-zoom-in w-full h-[192px] rounded-lg  object-cover hover:scale-105 transition-transform duration-300`}
                            />
                            <p
                              className={`${index === 2 && convertStringToArray(datadetail?.pictureGallery).length > 3 ? "absolute" : "hidden"}  bottom-4 right-4 px-4 py-2  pv:max-ph:py-0  pv:max-ph:right-0  pv:max-ph:bottom-0 bg-white text-primary_light bg-opacity-60 rounded-lg `}
                            >
                              {t("activity_label_viewmoreimg")}
                            </p>
                          </a>
                        ) : (
                          <div className="w-full h-[100px] bg-gray-200 flex items-center justify-center">
                            No image
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            </Fancybox>
          </div>
        </div>

        {/* Other information */}
        <div className="grid grid-cols-3 gap-4  pv:max-lg:grid-cols-1">
          <div className="col-span-2 pv:max-lg:col-span-1 ">
            <div className="  shadow-custom-activity rounded-lg  my-10 pv:max-lg:my-2  ">
              <div className="flex h-[100px] items-center pv:max-lg:h-full pv:max-lg:py-2  justify-around  pv:max-lg:flex-col pv:max-lg:gap-2 pv:max-lg:w-[95%] pv:max-lg:mx-auto text-[1rem]">
                <div className=" pv:max-lg:w-full">
                  <p className="   whitespace-pre-line text-primary text-justify leading-relaxed ">
                    {t("activity_label_architeture")}
                  </p>
                  <div className="flex items-center gap-1">
                    <p className=" whitespace-pre-line text-primary_light text-justify leading-relaxed font-bold">
                      {datadetail?.architecture}
                    </p>
                  </div>
                </div>
                <div className="pv:max-lg:w-full">
                  <p className="  whitespace-pre-line text-primary text-justify leading-relaxed ">
                    {t("activity_label_scale")}
                  </p>
                  <div className="flex items-center gap-1">
                    <p className="  text-primary_light font-bold">
                      {datadetail?.scale}
                    </p>
                  </div>
                </div>
                <div className=" pv:max-lg:w-full">
                  <p className="   whitespace-pre-line text-primary  leading-relaxed ">
                    {t("activity_label_projecttype")}
                  </p>
                  <div className="flex items-center gap-1">
                    <p className="  text-primary_light font-bold">
                      {datadetail?.type}
                    </p>
                  </div>
                </div>
                <div className=" pv:max-lg:w-full">
                  <p className="   whitespace-pre-line text-primary text-justify leading-relaxed ">
                    {t("activity_label_status")}
                  </p>
                  <div className="flex items-center gap-1 ">
                    <p className=" text-primary_light font-bold">
                      {datadetail?.status}
                    </p>
                  </div>
                </div>
                <div className=" pv:max-lg:w-full">
                  <p className="    whitespace-pre-line text-primary text-justify leading-relaxed ">
                    {t("activity_label_date")}
                  </p>
                  <div className="flex items-center gap-1 ">
                    <p className=" text-primary_light font-bold">
                      {datadetail?.completionDate}
                    </p>
                  </div>
                </div>
                {/* project Type Mobile */}
                <div className=" pv:max-lg:w-full lg:hidden">
                  <p className=" whitespace-pre-line text-primary text-justify leading-relaxed ">
                    {t("activity_label_investments")}
                  </p>
                  <div className="flex items-center gap-1 ">
                    <p className=" text-primary_light font-bold">
                      {formatNumber(datadetail?.price)} USD
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-1 pv:max-lg:hidden  ">
            <div className="shadow-custom-activity  rounded-lg h-[100px] my-10 pv:max-lg:my-2 flex flex-col  p-2  justify-center ">
              <p className="text-[1rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary leading-relaxed ">
                {t("activity_label_investments")}
              </p>
              <p className="text-primary_light text-[2rem]">
                {formatNumber(datadetail?.price)} USD
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4 pv:max-lg:grid-cols-1">
          <div className="col-span-2 pv:max-lg:grid-cols-1 ">
            <div className="">
              <div className="ProseMirror text-primary">
                {parse(datadetail?.content)}
              </div>
            </div>
            <div className="mt-6 p-[10px]">
              <div className="w-full ">
                <YouTube
                  videoId={datadetail?.pictureUrl}
                  opts={opts}
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
          <div className=" pv:max-lg:w-full ">
            <div className="col-span-1 shadow-custom-activity h-[180px]   rounded-lg py-[20px] lg:max-xl:py-0 flex gap-2 items-center lg:max-xl:flex-col lg:max-xl:h-[300px]">
              <div className="p-4 m-2 rounded-lg bg-primary/5">
                <img
                  className="h-[120px] pv:max-md:h-[80px]  "
                  src={imglogo}
                ></img>
              </div>
              <div className="">
                <div className="">
                  <p className="text-[1rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary text-justify leading-relaxed ">
                    {t("activity_label_investor")}
                  </p>
                  <p className="text-[1rem] text-primary_light">
                    {datadetail?.investor}
                  </p>
                </div>
                <div className="flex gap-2 text-base text-primary_light items-center">
                  <Icon icon={"ic:outline-phone"}></Icon>
                  <p className="">+ 61 411 896 553</p>
                </div>
                <div className="flex gap-2 text-base text-primary_light items-center">
                  <Icon icon={"ic:outline-email"}></Icon>
                  <p className="">info@idg-global.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(ActivityDetail);
